import { Location } from '@angular/common'
import { Component, HostBinding, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { DashboardGoalCard, MiniTask, PerformanceMetric } from 'src/app/leader-toolkit/models/dashboard.model'
import { AuthManager } from 'src/app/shared/auth/AuthManager'
import { AppPractice, GrowthToolkitClient } from 'src/app/shared/services/ppv.api'


@Component({
  selector: 'vc-leader-goal-toolkit-details',
  standalone: false,
  templateUrl: './leader-goal-toolkit-details.component.html',
  styleUrl: './leader-goal-toolkit-details.component.scss'
})
export class LeaderGoalToolkitDetailsComponent implements OnInit {
 @HostBinding('class.full-flex-height') fullFlexHeight = true

   constructor(
      private authManager: AuthManager,
      private route: ActivatedRoute,
      private location: Location,
      private growthToolkitClient: GrowthToolkitClient,
      public router: Router
   ) {}

   ngOnInit(): void {
      const hospitalId = this.route?.snapshot?.paramMap?.get('id');
   }
   hospitalName: string = 'FL - Apopka - Park Ave';

  // 1. Progress Bars Data
  performanceMetrics: PerformanceMetric[] = [
    { label: 'Activate Paid Ads', percentage: 90, colorClass: 'teal' },
    { label: 'Tail-O-Phone', percentage: 60, colorClass: 'purple' },
    { label: 'Optimize Home Delivery', percentage: 40, colorClass: 'orange' },
    { label: 'Enhance Dental Services', percentage: 30, colorClass: 'yellow' }
  ];

  // 2. Mini Tasks List (Top Right Card)
  miniTasks: MiniTask[] = [
    { taskName: 'Example of task 1', date: '10/05/2025', status: 'Past Due' },
    { taskName: 'Example of task 2', date: '10/18/2025', status: 'Complete' },
    { taskName: 'Upcoming Meeting', date: '11/05/2025', status: 'Pending' },
    { taskName: 'Upcoming Meeting', date: '11/22/2025', status: 'Pending' }
  ];



  // 3. Goal Cards (Blue Boxes)
  activeGoals: DashboardGoalCard[] = [
    {
      title: 'Activate Paid Ads',
      subTitle: 'AMOUNT PER WEEK',
      currentValue: '$275',
      goalValue: '$300 GOAL',
      links: ['Digital Paid Media Overview', 'Paid Digital Ads Form', 'Book Now Landing Page Example'],
      status: 'Active'
    },
    {
      title: 'Tail-O-Phone',
      subTitle: 'DISPOSITIONS PER DAY',
      currentValue: '20',
      goalValue: '25 GOAL',
      links: ['Accessible via vetcorone.com', 'PetDesk Texting Dashboard', 'Vetcor\'s Two-Way Text Templates'],
      status: 'Active'
    },
    {
      title: 'Optimize Home Delivery',
      subTitle: 'CHECKOUT LINKS',
      currentValue: '12',
      goalValue: '20 GOAL',
      links: ['Form to Launch Home Delivery', 'How to Promote Your Online Store', 'Utilizing Checkout Links'],
      status: 'Active'
    }
  ];

  pastGoals: DashboardGoalCard[] = [
    {
      title: 'Enhance Dental Services',
      subTitle: 'SALES PER MONTH',
      currentValue: '12',
      goalValue: 'CONGRATS! You reached your goal!',
      links: ['Add Dental Promotional Material', 'Vetcor\'s Dental Guidelines'],
      status: 'Past'
    }
  ];

  // Helper for Status Badge Color
  getStatusClass(status: string): string {
    switch(status) {
      case 'Past Due': return 'badge-red';
      case 'Complete': return 'badge-green';
      case 'Pending': return 'badge-blue';
      default: return '';
    }
  }
  
}

